export default function BlkBlockLanding() {
  const heroImage = "/images/blk-block-hero.jpg";
  const donateUrl = "https://givebutter.com/theblkbloc";

  const planSteps = [
    {
      step: "Step 1",
      title: "Build One Unity Rising",
      text: "We are building a nonprofit focused on community, culture, education, wellness, and economic opportunity.",
    },
    {
      step: "Step 2",
      title: "Launch Melanin & Mocha",
      text: "Melanin & Mocha will be our first community gathering space with coffee, tea, snacks, events, workshops, and connection.",
    },
    {
      step: "Step 3",
      title: "Grow Community Programs",
      text: "We will offer youth activities, business education, financial literacy, cultural events, wellness programs, and community support.",
    },
    {
      step: "Step 4",
      title: "Build the First Blk Bloc",
      text: "Our long-term goal is to create a walkable cultural district where people can live, work, learn, shop, and build together.",
    },
  ];

  const programs = [
    "Youth activities and leadership",
    "Business and financial education",
    "Wellness and family support",
    "Cultural events and storytelling",
    "Small business support",
    "Community gatherings",
  ];

  return (
    <main className="min-h-screen bg-[#f7f2e8] text-[#181411]">
      <header className="sticky top-0 z-50 border-b border-black/10 bg-[#f7f2e8]/90 backdrop-blur-xl">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 lg:px-8">
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-[#8a755d]">
              One Unity Rising
            </p>
            <p className="text-lg font-semibold">The Blk Bloc</p>
          </div>

          <nav className="hidden items-center gap-6 text-sm text-[#5b4f45] md:flex">
            <a href="#plan" className="hover:text-black">Our Plan</a>
            <a href="#mocha" className="hover:text-black">Melanin & Mocha</a>
            <a href="/books" className="hover:text-black">Books</a>
            <a href="#involved" className="hover:text-black">Get Involved</a>
          </nav>

          <a
            href={donateUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-full bg-[#171310] px-5 py-2.5 text-sm font-medium text-white"
          >
            Donate
          </a>
        </div>
      </header>

      <section className="relative overflow-hidden">
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImage})` }}
        />
        <div className="absolute inset-0 bg-black/65" />

        <div className="relative mx-auto max-w-7xl px-5 py-28 text-white lg:px-8">
          <p className="mb-4 text-[11px] uppercase tracking-[0.32em] text-[#e9cfaa]">
            Community • Culture • Ownership
          </p>

          <h1 className="max-w-3xl text-5xl font-semibold leading-tight sm:text-6xl">
            Building community, culture, and opportunity together.
          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-8 text-white/85">
            One Unity Rising is a nonprofit vision created to build stronger
            communities through education, wellness, culture, small business,
            family support, and economic opportunity.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href="#plan"
              className="rounded-full bg-white px-6 py-3 text-sm font-medium text-black"
            >
              See Our Plan
            </a>
            <a
              href={donateUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="rounded-full border border-white/30 px-6 py-3 text-sm font-medium text-white"
            >
              Support the Mission
            </a>
          </div>
        </div>
      </section>

      <section id="plan" className="px-5 py-20 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#a88967]">
            Our Plan
          </p>
          <h2 className="mt-3 max-w-3xl text-4xl font-semibold sm:text-5xl">
            We are starting simple and building step by step.
          </h2>

          <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {planSteps.map((item, index) => (
              <div key={index} className="rounded-[28px] bg-white p-6 shadow-sm">
                <p className="text-sm font-semibold text-[#b8742b]">
                  {item.step}
                </p>
                <h3 className="mt-3 text-xl font-semibold">{item.title}</h3>
                <p className="mt-4 text-sm leading-7 text-[#5b4f45]">
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="mocha" className="bg-[#171310] px-5 py-20 text-white lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-10 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#d0b182]">
              First Launch
            </p>
            <h2 className="mt-3 text-4xl font-semibold sm:text-5xl">
              Melanin & Mocha
            </h2>
            <p className="mt-6 text-lg leading-8 text-white/75">
              Melanin & Mocha will be a community café and gathering space. It
              will be a place for coffee, tea, snacks, events, workshops,
              conversations, creativity, and connection.
            </p>
            <p className="mt-5 text-lg leading-8 text-white/75">
              This café is the first step toward the larger Blk Bloc vision. It
              gives us a real place to gather, serve people, host programs, and
              grow support for the future district.
            </p>
          </div>

          <div className="rounded-[32px] bg-white/10 p-8">
            <h3 className="text-2xl font-semibold">What it will include</h3>
            <ul className="mt-6 space-y-4 text-white/80">
              <li>• Coffee, tea, drinks, and simple snacks</li>
              <li>• Community events and workshops</li>
              <li>• Vendor days and small business support</li>
              <li>• Youth and family-friendly gatherings</li>
              <li>• A warm space for culture, creativity, and connection</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="px-5 py-20 lg:px-8">
        <div className="mx-auto max-w-7xl">
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#a88967]">
            Programs
          </p>
          <h2 className="mt-3 max-w-3xl text-4xl font-semibold sm:text-5xl">
            Programs we want to grow.
          </h2>

          <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {programs.map((program, index) => (
              <div key={index} className="rounded-[24px] bg-white p-6 shadow-sm">
                <p className="text-lg font-semibold">{program}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#ece3d5] px-5 py-20 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-2">
          <div>
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#a88967]">
              Long-Term Vision
            </p>
            <h2 className="mt-3 text-4xl font-semibold sm:text-5xl">
              The Blk Bloc
            </h2>
          </div>

          <p className="text-lg leading-8 text-[#5b4f45]">
            The Blk Bloc is our long-term vision for a walkable cultural
            district with businesses, community programs, wellness spaces,
            learning spaces, housing, events, and opportunities for ownership.
            We are starting with what we can build now, then growing from there.
          </p>
        </div>
      </section>

      <section id="involved" className="px-5 py-20 lg:px-8">
        <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-2">
          <div className="rounded-[32px] bg-white p-8 shadow-sm">
            <h2 className="text-3xl font-semibold">Get involved</h2>
            <p className="mt-4 leading-7 text-[#5b4f45]">
              We are looking for volunteers, partners, donors, vendors, business
              owners, educators, creatives, wellness workers, and community
              members who want to help build.
            </p>

            <a
              href="https://stats.sender.net/forms/b2kAmK/view"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-block rounded-full bg-[#171310] px-6 py-3 text-sm font-medium text-white"
            >
              Submit Interest
            </a>
          </div>

          <div className="rounded-[32px] bg-[#171310] p-8 text-white">
            <h2 className="text-3xl font-semibold">Support the mission</h2>
            <p className="mt-4 leading-7 text-white/75">
              Donations help us build the foundation, launch community events,
              prepare Melanin & Mocha, create programs, and move toward the
              first Blk Bloc location.
            </p>

            <a
              href={donateUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-block rounded-full bg-white px-6 py-3 text-sm font-medium text-black"
            >
              Donate
            </a>
          </div>
        </div>
      </section>

      <footer className="bg-[#171310] px-5 py-10 text-white lg:px-8">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-lg font-semibold">One Unity Rising</p>
            <p className="mt-2 text-sm text-white/60">
              theblkblocteam@oneunityrising.org
            </p>
          </div>

          <p className="text-sm text-white/50">
            © {new Date().getFullYear()} One Unity Rising
          </p>
        </div>
      </footer>
    </main>
  );
}